// @flow
import * as React from "react"
import urls from "data/router/urls"
import { SettingListLink } from "./styled"

const SettingList = () => (
  <React.Fragment>
    <SettingListLink to={urls.account.password}>Reset Password</SettingListLink>
    <SettingListLink to={urls.account.payments}>Payment Method</SettingListLink>
    <SettingListLink to={urls.account.deleteAccount}>
      Delete Account
    </SettingListLink>
  </React.Fragment>
)

export default SettingList



// WEBPACK FOOTER //
// ./src/pages/Account/Routes/SettingList/index.js